module.exports = __webpack_public_path__ + "static/media/webiconred.154f4553.png";